<template>
  <FriedModal @close="handleClose">
    <template #header>
      <FriedModalHeader :header="$t('approve-document')" />
    </template>
    <p>
      {{ $t('by-clicking-approve-document-i') }},
      <strong class="name">{{ recipient.fullName }}</strong>
      {{ $t('verify-that-im-approving-the-document') }}:
      <strong class="document-name">{{ document.name }}</strong>
      {{ $t('and-the-sender-will-be-notified') }}
    </p>
    <template #footer>
      <FriedModalButtonsFooter>
        <FriedButton
          data-external="approve-modal-cancel-btn"
          :button-type="ButtonType.Secondary"
          @click="handleClose"
        >
          {{ $t('cancel') }}
        </FriedButton>
        <FriedButton data-external="approve-modal-approve-btn" @click="handleApprove">
          {{ $t('approve') }}
        </FriedButton>
      </FriedModalButtonsFooter>
    </template>
  </FriedModal>
</template>

<script lang="ts">
import { ButtonType } from '@getaccept/fried-tofu';
import { RecipientStatus } from '@getaccept/lib-shared-new/src/recipients/enums/recipient-status';
import { throttle } from '@getaccept/lib-shared-new/src/helpers';
import type { SigningPageDocument } from '@getaccept/lib-shared-new/src/types/signing-page-document';
import type { SigningPageRecipient } from '@getaccept/lib-shared-new/src/types/signing-page-recipient';
import type { SigningPageUser } from '@getaccept/lib-shared-new/src/types/signing-page-user';
import type { PropType } from 'vue';
import { watch, defineComponent } from 'vue';

export default defineComponent({
  props: {
    document: { type: Object as PropType<SigningPageDocument>, required: true },
    sender: { type: Object as PropType<SigningPageUser>, required: true },
    recipient: { type: Object as PropType<SigningPageRecipient>, required: true },
    authId: { type: String, required: true },
  },
  emits: ['close', 'approve'],
  setup(props, { emit }) {
    const approved = () => {
      if (props.recipient.status === RecipientStatus.Approved) {
        handleClose();
      }
    };
    watch(() => props.recipient.status, approved);

    const handleClose = () => {
      emit('close');
    };
    const emitApprove = () => {
      emit('approve');
    };
    const handleApprove = throttle(emitApprove, 1000);

    return {
      handleClose,
      handleApprove,
      ButtonType,
      approved,
    };
  },
});
</script>
